<div class="container">
  <div class="grid">
    <div class="row">
      <div class="col-md-12">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>